import React from 'react';
import { FaTimes } from 'react-icons/fa';
import './CareersModal.css';
import careersBg from '../../assets/careers-bg.jpg'; 

const CareersModal = ({ onClose }) => {
  return (
    <div className="careers-backdrop">
      <div className="careers-container">
        
        {/* Close Button */}
        <button className="btn-close-careers" onClick={onClose}>
          <FaTimes />
        </button>

        {/* Left Side: Image */}
        <div 
            className="careers-image" 
            style={{ backgroundImage: `url(${careersBg})` }}
        ></div>

        {/* Right Side: Content */}
        <div className="careers-content">
            <div className="careers-subtitle">Empowering Talent, Driving Success</div>
            <h2>Join Our Team</h2>
            
            <p className="careers-tagline">
              Experience a world-class working environment
            </p>
            
            <p className="careers-description">
                At Provenance, we believe that the success of an organization stems from the 
                satisfaction of its employees. That’s why we cultivate an open, employee-friendly 
                work culture designed to empower individuals and foster collaboration.
                <br /><br />
                If you have a progressive mindset, a forward-thinking attitude, and the 
                determination to excel in the world of commodity trading, we want to hear from you.
            </p>

            <div className="careers-contact">
                Send your CV to: 
                <a href="mailto:swati@provenance-agri.com" className="email-link">swati@provenance-agri.com</a>
            </div>
        </div>

      </div>
    </div>
  );
};

export default CareersModal;